var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"applanding"}},[_c('section',[_c('div',{staticClass:"py-1"}),_c('v-container',{staticClass:"text-center"},[_c('h2',{staticClass:"display-2 font-weight-bold mb-3"},[_vm._v("SECURE APP LANDING PAGE")]),_c('v-responsive',{staticClass:"mx-auto mb-8",attrs:{"width":"56"}},[_c('v-divider'),_c('v-divider')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }